<template>
    <div class="mb-3">
        <button class="btn btn-primary w-100 d-block d-md-none" data-toggle="collapse" href="#filters">Filtros</button>

        <div id="filters" class="collapse d-md-block">
            <div class="card card-body shadow-sm">

                <div class="d-none d-md-block mb-1">
                    <h4 class="mb-n2">Filtros</h4>
                    <hr>
                </div>

                <div class="pb-3">

                    <h5 class="text-decoration-none hover-sm pointer-sm" data-toggle="collapse" href="#categories">
                        Categorías <i class="fa-angle-down fas d-md-none"></i>
                    </h5>

                    <div class="collapse d-md-block text-muted mt-3" id="categories">
                        <div class="pb-1" v-for="(category, index) in categories" :key="index"> 
                            <input type="checkbox" class="d-none" :value="category" v-model="selectedCategories" :id="category"> 
                            <label class="pointer" :class="{'text-primary': selectedCategories.includes(category)}" :for="category">{{category}}</label>                     
                        </div>
                    </div>
                </div>

            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'NoticeFilters',
    data(){
        return{
            selectedCategories: [],
        }
    },
    destroyed(){
        this.$store.commit('notice/setSelectedCategories', [])
    },
    watch:{
        selectedCategories(value){
            this.$store.commit('notice/setSelectedCategories', value)
        },
    },
    computed:{
        categories(){
            return require('@/assets/json/notices.json').categories
        },
    }
}
</script>